import { AlleleFormat, CaseClient, LabClient, QueriesClient, SharingSampleType } from "@app/api2/api";

export function toAlleleFormatName(format: AlleleFormat) {
    switch (format) {
        case AlleleFormat.CE_RU:
            return "CE/RU";
        case AlleleFormat.LUS:
            return "LUS";
        case AlleleFormat.LUSP:
            return "LUS+";
        default:
            return "NA";
    }
}

export async function getEnabledAlleleFormats(labId: number) {
    let client = new QueriesClient();
    let result = await client.getAlleleFormats(labId);
    return result.map(x => {
        return { format: x, label: toAlleleFormatName(x) }
    })
}


export async function getCaseAlleleFormat(param: { labId: number, caseId: number }) {
    let client = new CaseClient();
    let result = await client.getCaseBasicInfo(param.labId, param.caseId);
    return result.alleleFormat
}

export function toSharingSampleTypeName(format: SharingSampleType) {
    switch (format) {
        case SharingSampleType.None:
            return "None";
        case SharingSampleType.All:
            return "All";
        case SharingSampleType.Evidence:
            return "Evidence";
        case SharingSampleType.Reference:
            return "Reference";
        case SharingSampleType.ForensicEnrollments:
            return "Forensic Enrollments";
        case SharingSampleType.QualityCases:
            return "Quality Cases";
        default:
            return "NA";
    }
}